import * as React from 'react';
import { createIcon } from '@chakra-ui/icons';

const ForwardIcon = createIcon({
  displayName: 'ForwardIcon',
  viewBox: '0 0 17 30',
  defaultProps: {
    w: '17px',
    h: '30px',
    mr: '0.25rem',
    color: 'brand.primary',
    fill: 'none',
  },
  path: (
    <>
      <path d="M2 2L14 15L2 28" stroke="#00324D" strokeWidth="3" />
    </>
  ),
});

export default ForwardIcon;
